import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { VrstaKontnogPlana } from './vrsta-kontnog-plana';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-vrsta-kontnog-plana',
  templateUrl: './vrsta-kontnog-plana.component.html'
})
export class VrstaKontnogPlanaComponent 
extends BaseModalContainer<VrstaKontnogPlana> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaKontnogPlana>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
